import { downloadFromBlob } from '../blob-util';
import { Downloader } from '../interfaces/downloader.interface';

export class CsvDownloader implements Downloader {
  /**
   * The name of the file to be downloaded.
   */
  private readonly fileName: string;

  /**
   * The delimiter to use in the CSV file.
   */
  private readonly delimiter: string = ',';

  /**
   * @param fileName
   * @param delimiter
   */
  constructor(
    fileName: string,
    delimiter = ','
  ) {
    this.fileName = fileName.endsWith('.csv') ? fileName : `${fileName}.csv`;
    this.delimiter = delimiter;
  }

  /**
   * Downloads a CSV file.
   *
   * @param headers
   * @param rows
   */
  download(headers: string[], rows: string[][]): void {
    try {
      const data = this.createCsvContent(headers, rows);

      downloadFromBlob(
        this.fileName,
        [data],
        {type: 'text/csv'}
      );
    } catch (error) {
      console.error('Error downloading CSV file:', error);
    }
  }

  /**
   * Creates the CSV content.
   *
   * @param headers
   * @param rows
   */
  private createCsvContent(headers: string[], rows: string[][]): string {
    let content= '';

    if (headers) {
      content += headers.map(header => this.escapeValue(header)).join(this.delimiter) + '\n';
    }

    for (const row of rows) {
      content += row.map(cell => this.escapeValue(cell)).join(this.delimiter) + '\n';
    }

    return content;
  }

  /**
   * Escapes the value with double quotes.
   *
   * @param value
   */
  private escapeValue(value: string): string {
    if (value.includes('"')) {
      value = value.replace(/"/g, '""');
    }

    return `"${value}"`;
  }
}
